import { render, staticRenderFns } from "./CoachDashboardView.vue?vue&type=template&id=4ecd3ee3&"
import script from "./CoachDashboardView.ts?vue&type=script&lang=js&"
export * from "./CoachDashboardView.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports